import { useContext } from "react";
import { ListViewContext } from "./ListViewContext";

/**
 * Hook to access the listview context
 * @returns The listview context
 * @throws Error if used outside of a ListView component
 */
export function useListView() {
  const context = useContext(ListViewContext);

  if (context == null) {
    throw new Error("useListView must be wrapped in <ListView />");
  }

  return context;
}
